import React from 'react';
import { Mail, Shield } from 'lucide-react';

interface LogoIconProps {
  size?: 'sm' | 'md' | 'lg';
}

const LogoIcon: React.FC<LogoIconProps> = ({ size = 'md' }) => {
  const sizes = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16'
  };

  const iconSizes = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };

  return (
    <div className={`relative ${sizes[size]} aspect-square flex items-center justify-center`}>
      <div className="relative">
        {/* Mail icon with gradient */}
        <div className="relative">
          <Mail 
            className={`${iconSizes[size]} text-blue-600`}
            strokeWidth={2.5}
          />
        </div>
        
        {/* Shield overlay */}
        <Shield 
          className={`absolute inset-0 ${iconSizes[size]} text-indigo-600 opacity-30`}
          strokeWidth={1.5}
        />
        
        {/* Decorative dots */}
        <div className="absolute -right-1 -top-1 h-1.5 w-1.5 bg-blue-500 rounded-full" />
        <div className="absolute -left-1 -bottom-1 h-1.5 w-1.5 bg-indigo-500 rounded-full" />
      </div>
    </div>
  );
};

export default LogoIcon;